import { API } from "aws-amplify";
import { getJoinOrganizationRequest } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_JOIN_ORG_REQUEST: APITypes.JoinOrganizationRequest = {
  __typename: "JoinOrganizationRequest",
  id: "",
  userID: "",
  requestStatus: APITypes.JoinOrganizationRequestStatus.Pending,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getJoinOrgRequest = async (
  requestID: string
): Promise<LoaderData<APITypes.JoinOrganizationRequest>> => {
  try {
    const response = (await API.graphql({
      query: getJoinOrganizationRequest,
      variables: {
        id: requestID,
      },
    })) as { data?: APITypes.GetJoinOrganizationRequestQuery };

    return {
      success: true,
      data: response.data?.getJoinOrganizationRequest || EMPTY_JOIN_ORG_REQUEST,
    };
  } catch (error) {
    console.error("error getting join organization request", error);
    return {
      success: false,
      data: EMPTY_JOIN_ORG_REQUEST,
      error,
    };
  }
};
